import { useEffect, useState } from "react";
import DataTable from "../../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";

const ServiceDeleteEndpoint = ApiEndpoints.locService.locServiceDelete;
const ServiceListEndpoint = ApiEndpoints.locService.locServiceList;


const blogEditPath = "edit-logistics";
const tableHeader = ["Page Name","Slug", "Category Name"];
const tbody = ["page_name", "slug", "category_name"];

export default function LogiststicIndustries() {
  const [data, setData] = useState([]);
  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", ServiceListEndpoint);
      const result = response.dynamic_pages;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    dataFetch();
  }, []);


  const handleDelete = async (dynamicpage_id) => {
    const payload = { dynamicpage_id };
    try {
      const response = await ApiRequest("POST", ServiceDeleteEndpoint, payload);
      toast.success(response.message)
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: 'Logistic Service Management',
    user: 'Admin',
    innerpage: 'Logistic Service Management / Logistics'
  }
  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-logistics"> Add + </Link>
        <DataTable data={data} tableHeader={tableHeader}
          tbody={tbody} editPath={blogEditPath} onDelete={handleDelete} />
      </div>
    </>
  );
}



